import { render, staticRenderFns } from "./JamList.vue?vue&type=template&id=3af5513c&scoped=true"
import script from "./JamList.vue?vue&type=script&lang=js"
export * from "./JamList.vue?vue&type=script&lang=js"
import style0 from "./JamList.vue?vue&type=style&index=0&id=3af5513c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af5513c",
  null
  
)

export default component.exports